import Page from "../pages/Terms";
import { pageMeta } from "../lib/meta";
export const meta = () => pageMeta({ title: "Terms & Conditions | Gazar", description: "Terms & Conditions for gazar.dev operated by QUEEK LIMITED", path: "/terms" });
export default function Terms() { return <Page />; }
